export const gradeMap = {
    0: '幼儿园',
    1: '一年级',
    2: '二年级',
    3: '三年级',
    4: '四年级',
    5: '五年级',
    6: '六年级',
    7: '七年级',
    8: '八年级',
    9: '九年级',
    10: '高一年级',
    11: '高二年级',
    12: '高三年级',
}

// 学段和年级
export const schoolSection = [

    {
        id: 1,
        name: "小学",
        children: [
            {
                id: 1,
                name: "一年级",
            },
            {
                id: 2,
                name: "二年级",
            },
            {
                id: 3,
                name: "三年级",
            },
            {
                id: 4,
                name: "四年级",
            },
            {
                id: 5,
                name: "五年级",
            },
            {
                id: 6,
                name: "六年级",
            },
        ],
    },
    {
        id: 2,
        name: "初中",
        children: [{
            id: 7,
            name: "初一",
        },
        {
            id: 8,
            name: "初二",
        },
        {
            id: 9,
            name: "初三",
        }],
    },
    {
        id: 3,
        name: "高中",
        children: [{
            id: 10,
            name: "高一",
        },
        {
            id: 11,
            name: "高二",
        },
        {
            id: 12,
            name: "高三",
        }],
    }

];

export function getGrade(arr) {
    if (arr.length > 0) {
        let gradeArr = []
        arr.sort((a, b) => { return a - b }).forEach(item => {
            if (gradeArr.indexOf(item) < 0)
                gradeArr.push(item)
        })
        const combineArr = []
        let group = []
        gradeArr.forEach((item, index) => {
            if (item == 0) {
                combineArr.push([item])
            } else {
                if (group.length === 0) {
                    group.push(item)
                }
                else {
                    const gli = group.length - 1      //group last index
                    if (item == group[gli] + 1) {
                        group.push(item)
                    }
                    else {
                        combineArr.push(group)
                        group = [item]
                    }
                }
                if (index === gradeArr.length - 1)
                    combineArr.push(group)
            }
        })
        const res = []
        combineArr.forEach(item => {
            if (item.length === 1)
                res.push(gradeMap[item[0]])
            else {
                res.push(`${gradeMap[item[0]]}至${gradeMap[item[item.length - 1]]}`)
            }
        })
        return arrToStringByMap(res)
    }
    else return '-'
}

export function getRangeType(range) {
    const rangeMap = {
        province: '省级精品课程',
        place: '地方特色课程',
        school: '校本课程'
    }
    if (range)
        return rangeMap[range]
    else return ''
}

export function isTouchScreen() {
    // eslint-disable-next-line
    return ("ontouchstart" in window || (window.DocumentTouch && document instanceof DocumentTouch));
}

//根据字典将数组转为对应的字符串
export function arrToStringByMap(arr, map, split) {
    if (!split)
        split = ','
    let res = ''
    arr.forEach(item => {
        if (map)
            res += map[item] + split
        else
            res += item + split
    })
    return res.slice(0, -1)
}

// 计算音视频时长，单位秒
export function getDuration(duration) {
    console.log(duration, 'bs')
    if (typeof duration == 'string')
        duration = parseFloat(duration)
    const res = {}
    if (duration > 60) {
        res.sec = parseInt(duration % 60)
        const min = duration / 60
        if (min > 60) {
            res.min = parseInt(min % 60)
            res.hour = parseInt(min / 60)
        }
        else res.min = parseInt(min)
    }
    else res.sec = parseInt(duration)
    let resStr = ''
    if (res.hour)
        resStr += `${res.hour}时`
    if (res.min)
        resStr += `${res.min}分`
    if (res.sec)
        resStr += `${res.sec}秒`
    return resStr
}

// 计数一个对象数组中某个值的出现次数
export function getCountArray(array, key, value, needRes) {
    const res = []
    array.forEach(item => {
        if (item[key] == value)
            res.push(item)
    })
    if (needRes) {
        return {
            couter: res.length,
            data: res
        }
    }
    else return res.length
}

/**
 * 在数组中找到指定的object
 * @param targetArray 需要查询的数组
 * @param testObj 检索对象
 * @param returnIndex 是否返回index
 * @returns 带returnIndex返回index，否则返回查到的object
 */
export function findByKey(targetArray, testObj, returnIndex) {
    let res
    let itemIndex = null
    for (let i = 0; i < targetArray.length; i++) {
        let testMark = true
        const item = targetArray[i]
        for (let key in testObj) {
            if (Object.prototype.hasOwnProperty.call(item, key))
                if (item[key] === testObj[key])
                    testMark = testMark && true
                else testMark = false
            else testMark = false
        }
        if (testMark) {
            res = targetArray[i]
            itemIndex = i
            break
        }
    }
    if (returnIndex)
        return itemIndex
    return res
}

export function setQueryString(url, params) {
    if (!params || typeof (params) != 'object')
        return url
    let res = url + '?'
    for (let i in params) {
        const paramString = i + '=' + params[i] + '&'
        res += paramString
    }
    return res.substring(0, res.length - 1)
}

//节流
export const throttle = (fn, delay = 3000) => {
    let lastTime = 0, timer = null

    return function () {
        let _this = this
        let _arguments = arguments
        let now = new Date().getTime()
        clearTimeout(timer)
        // 判断上次触发的时间和本次触发的时间差是否小于delay,创建一个timer
        if (now - lastTime < delay) {
            timer = setTimeout(function () {
                lastTime = now
                fn.apply(_this, _arguments)
            }, delay)
        } else {
            // 否则可以直接执行
            lastTime = now
            fn.apply(_this, _arguments)
        }
    }
}

export function idCardNoCheck(id) {
    // 大陆
    const idCardReg = new RegExp(/(^[1-9]\d{5}(19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{2}[0-9Xx]$)/)
    // 香港
    const idCardHKReg = new RegExp(/^[A-Z]{1,2}[0-9]{6,10}[0-9A-Z]$/)
    // 澳门
    const idCardMCReg = new RegExp(/^[1|5|7][0-9]{6}[0-9A-Z]$/)
    // 台湾
    const idCardTWReg = new RegExp(/^[a-zA-Z][0-9]{9}$/)

    let res = false
    if (id.length == 18 || id.length == 15) {
        res = idCardReg.test(id)
    } else if (id.length == 10) {
        res = idCardTWReg.test(id)
    } else {
        res = idCardMCReg.test(id) || idCardHKReg.test(id)
    }
    return res
}

export const areaList = {
    province_list: {
        430000: "湖南省",
    },
    city_list: {
        430100: "长沙市",
        430200: "株洲市",
        430300: "湘潭市",
        430400: "衡阳市",
        430500: "邵阳市",
        430600: "岳阳市",
        430700: "常德市",
        430800: "张家界市",
        430900: "益阳市",
        431000: "郴州市",
        431100: "永州市",
        431200: "怀化市",
        431300: "娄底市",
        433100: "湘西土家族苗族自治州",
    },
    county_list: {
        430101: "市辖区",
        430102: "芙蓉区",
        430103: "天心区",
        430104: "岳麓区",
        430105: "开福区",
        430111: "雨花区",
        430112: "望城区",
        430121: "长沙县",
        430181: "浏阳市",
        430182: "宁乡市",
        430201: "市辖区",
        430202: "荷塘区",
        430203: "芦淞区",
        430204: "石峰区",
        430211: "天元区",
        430212: "渌口区",
        430223: "攸县",
        430224: "茶陵县",
        430225: "炎陵县",
        430281: "醴陵市",
        430301: "市辖区",
        430302: "雨湖区",
        430304: "岳塘区",
        430321: "湘潭县",
        430381: "湘乡市",
        430382: "韶山市",
        430401: "市辖区",
        430405: "珠晖区",
        430406: "雁峰区",
        430407: "石鼓区",
        430408: "蒸湘区",
        430412: "南岳区",
        430421: "衡阳县",
        430422: "衡南县",
        430423: "衡山县",
        430424: "衡东县",
        430426: "祁东县",
        430481: "耒阳市",
        430482: "常宁市",
        430501: "市辖区",
        430502: "双清区",
        430503: "大祥区",
        430511: "北塔区",
        430521: "邵东县",
        430522: "新邵县",
        430523: "邵阳县",
        430524: "隆回县",
        430525: "洞口县",
        430527: "绥宁县",
        430528: "新宁县",
        430529: "城步苗族自治县",
        430581: "武冈市",
        430601: "市辖区",
        430602: "岳阳楼区",
        430603: "云溪区",
        430611: "君山区",
        430621: "岳阳县",
        430623: "华容县",
        430624: "湘阴县",
        430626: "平江县",
        430681: "汨罗市",
        430682: "临湘市",
        430701: "市辖区",
        430702: "武陵区",
        430703: "鼎城区",
        430721: "安乡县",
        430722: "汉寿县",
        430723: "澧县",
        430724: "临澧县",
        430725: "桃源县",
        430726: "石门县",
        430781: "津市市",
        430801: "市辖区",
        430802: "永定区",
        430811: "武陵源区",
        430821: "慈利县",
        430822: "桑植县",
        430901: "市辖区",
        430902: "资阳区",
        430903: "赫山区",
        430921: "南县",
        430922: "桃江县",
        430923: "安化县",
        430981: "沅江市",
        431001: "市辖区",
        431002: "北湖区",
        431003: "苏仙区",
        431021: "桂阳县",
        431022: "宜章县",
        431023: "永兴县",
        431024: "嘉禾县",
        431025: "临武县",
        431026: "汝城县",
        431027: "桂东县",
        431028: "安仁县",
        431081: "资兴市",
        431101: "市辖区",
        431102: "零陵区",
        431103: "冷水滩区",
        431121: "祁阳县",
        431122: "东安县",
        431123: "双牌县",
        431124: "道县",
        431125: "江永县",
        431126: "宁远县",
        431127: "蓝山县",
        431128: "新田县",
        431129: "江华瑶族自治县",
        431201: "市辖区",
        431202: "鹤城区",
        431221: "中方县",
        431222: "沅陵县",
        431223: "辰溪县",
        431224: "溆浦县",
        431225: "会同县",
        431226: "麻阳苗族自治县",
        431227: "新晃侗族自治县",
        431228: "芷江侗族自治县",
        431229: "靖州苗族侗族自治县",
        431230: "通道侗族自治县",
        431281: "洪江市",
        431301: "市辖区",
        431302: "娄星区",
        431321: "双峰县",
        431322: "新化县",
        431381: "冷水江市",
        431382: "涟源市",
        433101: "吉首市",
        433122: "泸溪县",
        433123: "凤凰县",
        433124: "花垣县",
        433125: "保靖县",
        433126: "古丈县",
        433127: "永顺县",
        433130: "龙山县",
    }
};

